import { HideOverflow } from 'components';
import { LongSectionP05P08, BoxP05 } from '../IntendendComponents';

const Prac05 = () => {
  return (
    <HideOverflow>
      <LongSectionP05P08 />
      <BoxP05 />
      <LongSectionP05P08 />
      <BoxP05 />
      <LongSectionP05P08 />
    </HideOverflow>
  );
};

export default Prac05;
